<template>
  <div class="header mt-0 mt-lg-5 pt-0 pt-lg-5 pl-0 pl-lg-5" :class="clase">
      <div class="row m-0 fondo">
          <div class="col-lg-6 pt-md-4">
            <h1 :class="{'interno' : !btnurl}">{{ msg }}</h1>
            <div class="idea" v-html="idea"></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderSeguros',
  props: {
    msg: String,
    idea: String,
    btnurl: String,
    btntitle: String,
    clase: String,
  },
  computed: {
  },
  mounted: function(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flechalinks {
    height: 15px;
    margin-left: 10px;
}
.btn-primary {
    background-color: #08028A !important;
    border-radius: 0;
    border: 4px solid #00C4FF;
    padding: 6px 30px;
}
.btn-primary:hover {
    background-color: #00C4FF;
}
.btn-primary span {
    color: #00C4FF;
    font-size: 30px;
    font-weight: 600;
    line-height: 20px;
    display: block;
    float: right;
    margin-top: 3px;
    margin-left: 12px;
}
.btn-primary:hover span {
    color: #08028A;
}
.imgPrincipal {
    position: absolute;
    top:0 ;
    left:0;
    z-index: -1;
    width: 100%;
}
.header {
    color: #FFF;
    width: 100%;
    height: 410px;
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 50px !important;
}
.individuos-y-familias {
    background-image: url(../assets/images/pageinteriors_01seguros-venta-y-asesoria-subsec01-topbanner.png);
}
.profesionales-independientes-y-pymes {
    background-image: url(../assets/images/pageinteriors_01seguros-venta-y-asesoria-subsec02-topbanner.png);
}
.empresas-y-corporativos {
    background-image: url(../assets/images/pageinteriors_01seguros-venta-y-asesoria-subsec03-topbanner.png);
}
.margenTop {
    top: 180px !important;
}
h1 {
  font-weight: 200;
  font-size: 50px;
}
h1.interno {
  font-weight: 600;
  font-size: 35px;
}
.idea {
    margin: 50px 0 60px 0;
    font-size: 24px;
    line-height: 30px;
}
@media only screen and (max-width: 1024px){
    h1 {
        display: none;
    }
    .header {
        min-height: 470px;
        background-position: bottom center;
        background-size: cover;
    }
    .btn-primary {
        padding: 6px 15px;
    }
    .btn-primary:hover {
        background-color: #08028A !important;
        border: 4px solid #00C4FF;
    }
    .btn-primary:hover span {
        color: #000 !important;
    }
    .margenTop {
        top: 150px !important;
    }
    .margenTop h1 {
        font-size: 40px;
    }
    .individuos-y-familias {
        background-image: url(../assets/images/pageinteriors_01seguros-venta-y-asesoria-subsec01-topbanner-mobile.png);
    }
    .profesionales-independientes-y-pymes {
        background-image: url(../assets/images/pageinteriors_01seguros-venta-y-asesoria-subsec02-topbanner-mobile.png);
    }
    .empresas-y-corporativos {
        background-image: url(../assets/images/pageinteriors_01seguros-venta-y-asesoria-subsec03-topbanner-mobile.png);
    }
    .idea {
        margin: 40px 0 60px 0;
        font-size: 20px;
        line-height: 30px;
    }
}
</style>
